<template>
  <vx-card title="Package Checkout">
    <ValidationObserver v-slot="{ invalid }">
      <vs-row vs-type="flex" vs-justify="space-between">
        <vs-col vs-w="6" vs-xs="12">
          <vs-row vs-type="flex" class="mt-3">
            <vs-col vs-w="5">
              <label for class="vs-select--label">Selected Package</label>
              <vs-select
                :success="packages.options.indexOf(packages.selected) !== -1"
                success-text="Package is valid"
                :danger="packages.options.indexOf(packages.selected) !== -1"
                v-model="packages.selected"
                name="included"
                icon-pack="feather"
                icon="icon-alert-circle"
                icon-no-border
                class="select-large w-full"
              >
                <vs-select-item
                  :key="index"
                  :value="item"
                  :text="item.title"
                  v-for="(item,index) in packages.options"
                />
              </vs-select>
            </vs-col>
            <vs-col vs-w="4" vs-offset="0.5">
              <label for class="vs-select--label">Package Type</label>
              <vs-switch class="mt-2" v-model="form.isYearly">
                <template #on>Yearly</template>
                <template #off>Monthly</template>
              </vs-switch>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-3">
            <vs-checkbox v-model="form.isForeigner">I am not citizen of Turkey</vs-checkbox>
          </vs-row>
          <vs-row vs-type="flex" class="mt-3">
            <vs-col vs-w="5">
              <vs-input
                class="w-full"
                :label="form.isForeigner === true ? 'Passport Number' : 'Turkish Citizen ID'"
                v-model="form.identityNumber"
                placeholder="Ex: xxxxxxxxxxx"
              />
            </vs-col>
            <vs-col vs-w="4.7" vs-offset="0.3">
              <vs-input
                class="w-full"
                label="Birth Year"
                v-model="form.birthYear"
                placeholder="Ex: 1978"
              />
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-3">
            <vs-col vs-w="5">
              <vs-input class="w-full" label="Name" v-model="form.name" placeholder="Ex: John" />
            </vs-col>
            <vs-col vs-w="4.7" vs-offset="0.3">
              <vs-input
                class="w-full"
                label="Surname"
                v-model="form.surname"
                placeholder="Ex: Doe"
              />
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-3">
            <vs-col vs-w="5">
              <label for class="vs-select--label">Country</label>
              <country-select
                class="select-dropdown w-full"
                v-model="form.country"
                :country="form.country"
                topCountry="TR"
              />
            </vs-col>
            <vs-col vs-w="4.7" vs-offset="0.3">
              <label for class="vs-select--label">City</label>
              <region-select
                class="select-dropdown w-full"
                v-model="form.city"
                :country="form.country"
                :region="form.city"
              />
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-3">
            <vs-col vs-w="10">
              <label for class="vs-select--label">Registration Address</label>
              <vs-textarea v-model="form.registrationAddress" />
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col vs-w="5.8" vs-offset="0.2" vs-xs="12">
          <h5 class="mb-4">Billing Informations</h5>
          <vs-row vs-type="flex" class="mt-3">
            <vs-col vs-w="10">
              <vs-input
                class="w-full"
                label="Contact Name"
                v-model="form.billingAddress.contactName"
                placeholder="Ex: John Doe"
              />
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-3">
            <vs-col vs-w="5">
              <label for class="vs-select--label">Country</label>
              <country-select
                class="select-dropdown w-full"
                v-model="form.billingAddress.country"
                :country="form.billingAddress.country"
                topCountry="TR"
              />
            </vs-col>
            <vs-col vs-w="4.7" vs-offset="0.3">
              <label for class="vs-select--label">City</label>
              <region-select
                class="select-dropdown w-full"
                v-model="form.billingAddress.city"
                :country="form.billingAddress.country"
                :region="form.billingAddress.city"
              />
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-3">
            <vs-col vs-w="10">
              <label for class="vs-select--label">Billing Address</label>
              <vs-textarea v-model="form.billingAddress.address" />
              <vs-checkbox v-model="sameAddress">Use same address as registration address.</vs-checkbox>
            </vs-col>
          </vs-row>
          <vs-row vs-w="10">
            <vs-col vs-w="5">
              <label for class="vs-select--label">Currency</label>
              <vs-select
                v-model="form.currency"
                name="included"
                icon-pack="feather"
                icon="icon-alert-circle"
                icon-no-border
                class="select-large w-full"
              >
                <vs-select-item value="TRY" text="Turkish Lira" />
                <vs-select-item value="USD" text="US Dollar" />
              </vs-select>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col vs-w="10">
              <vs-alert color="success" class="mt-8 w-full">
                Total Cost:
                <template
                  v-if="form.currency === 'USD'"
                >${{form.isYearly === true ? packages.selected.yearlyCost : packages.selected.monthlyCost}}</template>
                <template v-else-if="form.currency === 'TRY'">
                  <template v-if="currency === 1">
                    Calculating...
                  </template>
                  <template
                    v-else
                  >{{Number(form.isYearly === true ? currency * packages.selected.yearlyCost : currency * packages.selected.monthlyCost).toFixed(2)}}₺</template>
                </template>
                <span
                  v-if="form.currency === 'TRY'"
                  class="ml-2"
                >[Estimated cost according to currency conversion]</span>
              </vs-alert>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" class="mt-3">
        <vs-col vs-type="flex" vs-justify="flex-end">
          <router-link to="/packages">
            <vs-button color="#00adef" type="border" class="mb-2">Back</vs-button>
          </router-link>
          <vs-button
            class="ml-3 mb-2"
            color="#4ca832"
            @click="createCheckoutForm"
            :disabled="invalid"
          >
            <i class="fa fa-credit-card mr-2"></i> Proceed to Iyzico
          </vs-button>
        </vs-col>
        <vs-alert
          class="mt-4 text-center"
          color="dark"
        >Important Reminder: The Customer (end-user) agrees to the transferral of their data related to the payment methods, membership and orders to iyzico Ödeme Hizmetleri A.Ş. (“iyzico”) and agrees to the processing and storage of these data by iyzico in order to finalize the payment transactions and to enable prevention, investigation and detection of fraudulent transactions as described in the most current version of the Privacy Policy at https://www.iyzico.com/en/privacy-policy/</vs-alert>
        <img
          class="mt-4"
          src="@/assets/images/svg/logo-band.svg"
          style="margin-left: auto;
    margin-right: auto;"
        />
      </vs-row>
    </ValidationObserver>
  </vx-card>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: "",
        surname: "",
        identityNumber: "",
        birthYear: "",
        city: "",
        country: "TR",
        registrationAddress: "",
        isYearly: false,
        isForeigner: false,
        currency: "TRY",
        billingAddress: {
          contactName: "",
          city: "",
          country: "TR",
          address: "",
        },
      },
      currency: 1,
      sameAddress: false,
      packages: {
        selected: {},
        options: [],
      },
    };
  },
  watch: {
    "form.currency": {
      handler(val) {
        if (val === "TRY") {
          this.getCurrency();
        }
      },
    },
    "form.registrationAddress": {
      handler(val) {
        if (this.sameAddress === true) {
          this.form.billingAddress.address = val;
        }
      },
      deep: true,
    },
    "form.country": {
      handler(val) {
        if (this.sameAddress === true) {
          this.form.billingAddress.country = val;
        }
      },
      deep: true,
    },
    "form.city": {
      handler(val) {
        if (this.sameAddress === true) {
          this.form.billingAddress.city = val;
        }
      },
      deep: true,
    },
    sameAddress: {
      handler(val) {
        if (val === true) {
          this.form.billingAddress.address = this.form.registrationAddress;
          this.form.billingAddress.country = this.form.country;
          setTimeout(() => {
            this.form.billingAddress.city = this.form.city;
          }, 100);
        }
      },
    },
  },
  methods: {
    async getCurrency() {
      const result = await this.$http.get("/user/getCurrency");
      this.currency = result.data.currency;
    },
    loadPackages() {
      this.$http.get("/user/packages").then((res) => {
        if (res.data.status === true) {
          this.packages.options = res.data.packages;
          let filteredPackage = res.data.packages.filter(
            (p) => p._id === this.$route.query.id
          );
          if (filteredPackage.length > 0) {
            this.packages.selected = filteredPackage[0];
          }
        }
      });
    },
    createCheckoutForm() {
      const data = {
        package_id: this.packages.selected._id,
        ...this.form,
      };
      this.$http
        .post("/user/checkout-form", { form: data })
        .then((res) => {
          if (res.data.status === true) {
            this.$swal({
              position: "bottom-start",
              icon: "success",
              toast: true,
              title:
                "Transaction successfully created, you're redirecting to Iyzico.",
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
            });
            window.location.href = res.data.redirectUrl;
          }
        })
        .catch((err) => {
          let errorMessage = err.response.data.message;
          if (err.response.data.error) {
            errorMessage = err.response.data.error;
          }
          this.$swal({
            position: "bottom-start",
            icon: "error",
            toast: true,
            title: errorMessage,
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },
  },
  created() {
    if (this.$route.query.packageType === "y") {
      this.form.isYearly = true;
    }
    this.loadPackages();
    this.getCurrency();
  },
};
</script>

<style lang="scss">
.select-dropdown {
  position: relative;
  height: 3em;
  background-color: #ffffff;
  width: auto;
  float: left;
  max-width: 100%;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  select {
    font-family: "helvetica neue", helvetica;
    font-size: 1rem;
    font-weight: 200;
    max-width: 100%;
    padding: 8px 24px 8px 10px;
    border: none;
    background-color: transparent;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    &:active,
    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
  &:after {
    content: " ";
    position: absolute;
    top: 50%;
    margin-top: -2px;
    right: 8px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #aaa;
  }
}
</style>
